export default "__VITE_ASSET__DjZnVEQl__"